import { render, staticRenderFns } from "./ContactSnippet.vue?vue&type=template&id=948efb58&scoped=true"
import script from "./ContactSnippet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactSnippet.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948efb58",
  null
  
)

export default component.exports